<template>
  <v-app-bar app color="primary">
    <template v-slot:prepend>
      <router-link to="/">
        <img :src="require('../assets/logo.svg')" alt="logo" style="height: 40px;">
      </router-link>
    </template>
    <v-app-bar-title class="headline text-uppercase">
      <span>{{ t('Proyecto_embryoscan') }}</span>
    </v-app-bar-title>

    <!-- Botón del menú hamburguesa para móviles -->
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon rounded="0" v-bind="props" class="h-100 hidden-sm-and-up">
          <v-app-bar-nav-icon></v-app-bar-nav-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="selectButton('home', '/')">
          <v-btn icon="mdi-home" flat rounded="0" class="h-100">
          </v-btn>
        </v-list-item>
        <v-list-item v-if="isInvestigador" @click="selectButton('pacientes', '/pacientes')">
          <v-btn flat rounded="0" class="h-100">
            {{ translatedPacientes }}
          </v-btn>
        </v-list-item>
        <v-list-item v-if="isInvestigador" @click="selectButton('scans', '/scans')">
          <v-btn flat rounded="0" class="h-100">
            {{ translatedEcografias }}
          </v-btn>
        </v-list-item>
        <v-list-item v-if="isClinico" @click="selectButton('citaciones', '/citaciones')">
          <v-btn flat rounded="0" class="h-100">
            {{ translatedCitaciones }}
          </v-btn>
        </v-list-item>
        <template v-if="!isLoggedIn">
          <v-list-item @click="selectButton('joinus', '/join-us')">
            <v-btn flat rounded="0" class="h-100">
              {{ translatedJoinus }}
            </v-btn>
          </v-list-item>
          <v-list-item @click="selectButton('login', '/login')">
            <v-btn flat rounded="0" class="h-100">
              {{ translatedLogin }}
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-menu>
              <template v-slot:activator="{ props }">
                <v-btn flat v-bind="props" rounded="0">
                  <v-icon>mdi-translate</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="setLocale('ca')">
                  <v-list-item-title>Català</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setLocale('en')">
                  <v-list-item-title>English</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setLocale('es')">
                  <v-list-item-title>Español</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
    <!-- Botons desktop -->
    <v-btn icon="mdi-home" flat rounded="0" class="h-100 hidden-xs" @click="selectButton('home', '/')">
    </v-btn>
    <v-btn v-if="isInvestigador" class="h-100 hidden-xs" @click="selectButton('pacientes', '/pacientes')">
      {{ translatedPacientes }}
    </v-btn>
    <v-btn v-if="isInvestigador" class="h-100 hidden-xs" @click="selectButton('scans', '/scans')">
      {{ translatedEcografias }}
    </v-btn>
    <v-btn v-if="isClinico" class="h-100 hidden-xs" @click="selectButton('citaciones', '/citaciones')">
      {{ translatedCitaciones }}
    </v-btn>
    <template v-if="!isLoggedIn">
      <v-btn flat rounded="0" class="h-100 hidden-xs" @click="selectButton('joinus', '/join-us')">
        {{ translatedJoinus }}
      </v-btn>
      <v-btn flat rounded="0" class="h-100 hidden-xs" @click="selectButton('login', '/login')">
        {{ translatedLogin }}
      </v-btn>
      <v-menu class="h-100 hidden-xs">
        <template v-slot:activator="{ props }">
          <v-btn flat v-bind="props" rounded="0" class="h-100 hidden-xs">
            <v-icon>mdi-translate</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="setLocale('ca')">
            <v-list-item-title>Català</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setLocale('en')">
            <v-list-item-title>English</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setLocale('es')">
            <v-list-item-title>Español</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <v-menu v-if="isLoggedIn">
      <template v-slot:activator="{ props }">
        <v-btn flat v-bind="props" rounded="0" class="h-100" prepend-icon="mdi-account">
          <span class="d-none d-sm-inline">{{ firstName }}</span>
        </v-btn>
      </template>

      <v-list>
        <v-list-item :to="`/perfil`" @click="resetButtons" prepend-icon="mdi-account-edit">
          <v-list-item-title>{{ t('Perfil') }}</v-list-item-title>
        </v-list-item>
        <v-list-item prepend-icon="mdi-translate">{{ t('Idioma') }}
          <v-menu activator="parent">
            <v-list>
              <v-list-item @click="setLocale('ca')">
                <v-list-item-title>Català</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setLocale('en')">
                <v-list-item-title>English</v-list-item-title>
              </v-list-item>
              <v-list-item @click="setLocale('es')">
                <v-list-item-title>Español</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item>
        <v-list-item @click="logout" prepend-icon="mdi-logout">{{ t('Cerrar_sesión') }}</v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

const { t, locale } = useI18n();
const selectedButton = ref('home');
const userStore = useUserStore();
const router = useRouter();

const isLoggedIn = computed(() => userStore.isLoggedIn);

const isClinico = computed(() =>
  userStore.userDetails?.roles?.includes('clinic')
);
const isInvestigador = computed(() =>
  userStore.userDetails?.roles?.includes('researcher')
);

const firstName = computed(() => userStore.userDetails?.first_name || t('Usuario'));

// Ensure translations update reactively
const translatedLogin = computed(() => t('Iniciar_sesión'));
const translatedJoinus = computed(() => t('Únete_a_nosotros'));
const translatedPacientes = computed(() => t('Pacientes'));
const translatedCitaciones = computed(() => t('Citaciones'));
const translatedEcografias = computed(() => t('Ecografías'));

// Recuperar el idioma guardado al cargar la aplicación
const userLocale = localStorage.getItem('userLocale');
if (userLocale) {
  locale.value = userLocale;
}

const setLocale = (newLocale) => {
  locale.value = newLocale;
  localStorage.setItem('userLocale', newLocale);
};

const selectButton = (button, path) => {
  selectedButton.value = button;
  router.push(path);
};

// Function to reset selected button state
const resetButtons = () => {
  selectedButton.value = null
}

// Function to log out the user
const logout = async () => {
  await userStore.logout();
  router.push('/login');
};
</script>